// Palette visuelle du thème COURANT — CCT-279.
//
// ⚠️ LE DÉFAUT CORRIGÉ. `CYB` est une constante SOMBRE, importée en dur par une quinzaine
// d'écrans qui ne consultaient jamais le thème : passer l'application en clair laissait la
// mission, la scène et la timeline en dark. L'utilisateur voyait un thème à moitié
// appliqué, sans savoir lequel des deux faisait foi.
//
// Un hook plutôt qu'un import : la palette devient une valeur qui suit le thème, et l'écran
// n'a rien à décider.
import { useTheme } from '../context/ThemeContext';
import { palette, type Palette } from '../utils/cyb';

export function usePalette(): Palette {
  const { isDarkTheme } = useTheme();
  return palette(isDarkTheme);
}
